<template>
  <router-view></router-view>
</template>

<script>
  export default {
    name: 'app'
  }
</script>

<style lang="scss">
  @import '../scss/style.scss';
</style>



// WEBPACK FOOTER //
// App.vue?362d33c0